$(document).ready(function () {
  if (window.location.href.indexOf('?filter') <= 0) {
    const defaultFilters = $('body').attr('data-default-filters');
    if (defaultFilters) {
      const values = defaultFilters.split('|').map(v => v.trim());
      $('.filter-group').each(function (index) {
        const valueToSelect = values[index];
        if (!valueToSelect) return;
        $(this).find('ul li').each(function () {
          const itemText = $(this).text().trim();
          if (itemText === valueToSelect) {
            $(this).find('input, button, label').first().trigger('click');
            return false;
          }
        });
      });
    } else {
      $('.filter-group').each(function () {
        $(this).find('ul li:first-child').find('input, button, label').first().trigger('click');
      });
    }
  }
});

